import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rt-base-more",
  "use": "rt-base-more-usage",
  "viewBox": "32 -232 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"32 -232 1024 1024\" id=\"rt-base-more\">\r\n<g>\r\n\t<circle cx=\"256\" cy=\"280\" r=\"64\" />\r\n\t<circle cx=\"544\" cy=\"280\" r=\"64\" />\r\n\t<circle cx=\"832\" cy=\"280\" r=\"64\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/rt-svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/more.svg
// module id = 1730
// module chunks = 228